import React, { createContext, useContext, useState } from 'react';

const TimesContext = createContext();

export const TimesProvider = ({ children }) => {
  const [timesUpdateTrigger, setTimesUpdateTrigger] = useState(0);

  const triggerTimesUpdate = () => {
    setTimesUpdateTrigger(prev => prev + 1);
  };

  return (
    <TimesContext.Provider value={{ timesUpdateTrigger, triggerTimesUpdate }}>
      {children}
    </TimesContext.Provider>
  );
};

export const useTimesUpdate = () => {
  const context = useContext(TimesContext);
  if (!context) {
    // Se o contexto não estiver disponível, retornar valores padrão
    return { timesUpdateTrigger: 0, triggerTimesUpdate: () => {} };
  }
  return context;
};
